// Shared OAuth scope metadata, used by both the authorize/consent screen
// (app/pages/oauth/authorize.js) and the customer "API Access" settings
// (app/components/ApiSettings.js). Keep in sync with the scopes configured in
// ray/config/initializers/doorkeeper.rb.

export const SCOPE_DESCRIPTIONS = {
  org_read:          'View your organization info',
  posts_read:        'Read your posts and engagement metrics',
  posts_write:       'Create, update, and delete posts, and upload images',
  destinations_read: 'View your connected social accounts',
}

// Ordered list for rendering checkboxes. `org_read` is the default scope and is
// always granted, so it is marked `required`.
export const ALL_SCOPES = [
  { name: 'org_read',          required: true  },
  { name: 'posts_read',        required: false },
  { name: 'posts_write',       required: false },
  { name: 'destinations_read', required: false },
]
